import CommonEmailChange from '../../../common/pages/secure/EmailChange'
import Config from '../../../Config'

class EmailChange extends CommonEmailChange {
  constructor (props) {
    super(props)
    this.userRoleUrl = 'admin'
    this.userRole = 'admin'
    this.apiUrl = Config.adminApiUrl.emailChange
  }
}

export default EmailChange



// WEBPACK FOOTER //
// ./src/admin/pages/secure/EmailChange.js